import {
  FETCH_FEATURE_FAILURE,
  FETCH_FEATURE_LOADING,
  FETCH_FEATURE_SUCCESS,
  FETCH_LEAVE_TYPES_FAILURE,
  FETCH_LEAVE_TYPES_SUCCESS,
  UPDATE_FEATURE_SELECTED,
  FETCH_HOLIDAYS_LOADING,
  FETCH_HOLIDAYS_SUCCESS,
  FETCH_HOLIDAYS_FAILURE,
  ADD_SETTING_LOADING,
  ADD_SETTING_SUCCESS,
  ADD_SETTING_FAILURE,
  DELETE_SETTING_FAILURE,
  DELETE_SETTING_SUCCESS,
  DELETE_SETTING_LOADING
} from '../Types/featureTypes';

// const initState = {
//   data: [
//     {
//       id: 1,
//       name: 'Organization Settings',
//       sections: [
//         {
//           eventKey: 'members',
//           // icon: <Icon as={FaUsers} />,
//           title: 'Members',
//           to: '/members'
//         },
//         {
//           eventKey: 'departments',
//           title: 'Department',
//           to: '/form-department'
//           // icon: <Icon as={MdApartment} />
//         },
//         {
//           eventKey: 'grade',
//           title: 'Grade',
//           to: '/form-grade'
//           // icon: <Icon as={MdGrade} />
//         }
//       ]
//     }
//   ]
// };

const initState = {
  data: [],
  leaveTypes: [],
  error: null,
  success: null,
  loading: true,
  holidays: [],
  addSettingLoading: false,
  addSettingError: null,
  deleteSettingLoading: false,
  deleteSettingError: null
};

const featureReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_FEATURE_LOADING:
    case FETCH_HOLIDAYS_LOADING:
      return {
        ...state,
        loading: true
      };
    case FETCH_FEATURE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case FETCH_HOLIDAYS_SUCCESS:
      return {
        ...state,
        loading: false,
        holidays: Array.isArray(action.payload) ? action.payload : [],
        error: null
      };
    case FETCH_FEATURE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...state.data, ...action.payload],
        error: null
      };
    case FETCH_LEAVE_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        leaveTypes: Array.isArray(action.payload) ? action.payload : [],
        error: null
      };
    case FETCH_LEAVE_TYPES_FAILURE:
    case FETCH_HOLIDAYS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case UPDATE_FEATURE_SELECTED:
      return {
        ...state,
        loading: false,
        selected: action.payload
      };

    case ADD_SETTING_LOADING:
      return {
        ...state,
        addSettingLoading: true,
        addSettingError: null
      };
    case ADD_SETTING_SUCCESS:
      return {
        ...state,
        addSettingLoading: false,
        addSettingError: null
      };
    case ADD_SETTING_FAILURE:
      return {
        ...state,
        addSettingLoading: false,
        addSettingError: action.payload
      };

    case DELETE_SETTING_LOADING:
      return {
        ...state,
        deleteSettingLoading: true,
        deleteSettingError: null
      };
    case DELETE_SETTING_SUCCESS:
      return {
        ...state,
        deleteSettingLoading: false,
        deleteSettingError: null,
        holidays: state.holidays.filter(holiday => holiday._id !== action.payload),
        leaveTypes: state.leaveTypes.filter(leaveType => leaveType._id !== action.payload)
      };
    case DELETE_SETTING_FAILURE:
      return {
        ...state,
        deleteSettingLoading: false,
        deleteSettingError: action.payload
      };

    default:
      return { ...state };
  }
};

export default featureReducer;
